import { Component, Inject } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { Router } from "@angular/router";

@Component({
    selector: 'app-bottom-sheet',
    templateUrl: 'bottom-sheet.html',
})
export class BottomSheet {

    

    constructor(private router:Router, private bottomSheetRef: MatBottomSheetRef<BottomSheet>, @Inject(MAT_BOTTOM_SHEET_DATA) public menuNo: any) {
    }

    openLink(event: MouseEvent,url : string = null): void {
        this.bottomSheetRef.dismiss(url);
        event.preventDefault();
    }

}